<div class="container bg2 page-admin footer-none">

  <section class="header fixed">

    <article class="header-page">

      <a class="close-btn" backButton></a>

      <div class="page-name-box">운영자의 말</div>

    </article>

  </section>

  <div class="fixed-text"
       *ngIf="fixedMsg">
    <div class="fixed-msg"
         [innerHTML]="fixedMsg.content | keepHtml"></div>
  </div>

  <section class="setting-page">
    <div class="inner wrap">

      <div class="setting-list">

        <div class="admin-box">
          <div class="reload-icon"
               *ngIf="is_loading; else articleLoaded">
            <img src="assets/img/loading_icon.gif">
          </div>

          <ng-template #articleLoaded>
            <div class="list-wrap" *ngIf="adminMsg; else noMessage">
              <div class="admin-tit-box"
                   [innerHTML]="adminMsg.title | keepHtml">
              </div>
              <div class="admin-des-box"
                   [innerHTML]="adminMsg.content | keepHtml">
              </div>
            </div>
          </ng-template>

          <ng-template #noMessage>
            <div class="admin-des-box">
              <br>운영자의 말이 없습니다.
            </div>
          </ng-template>
        </div>

      </div>

    </div>

  </section>

</div>
